import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './DesktopMenuItem.scss';
import notifyAnalytics from '../notify-analytics';

const DesktopMenuItem = ({ label, url, children }) => {
  const [active, updateActive] = useState(false);
  const navigate = () => {
    notifyAnalytics(label);
  };

  return (
    <li
      className={styles.desktopMenuItem}
      onMouseEnter={() => updateActive(true)}
      onMouseLeave={() => updateActive(false)}
    >
      <a className={styles.desktopMenuItemLink} href={url} onClick={navigate}>
        {label}
      </a>
      {active && children}
    </li>
  );
};

DesktopMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default DesktopMenuItem;
